import { ViewController, ButtonView, ButtonViewDelegate, VideoView, VideoControlBarView, NodeConnection,
         DataReceiveEvent, VideoReloadEvent, ChannelSwitchEvent, PlaybackStartEvent, ButtonClickEvent } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

// Uses srvg.videooptions,  srvg.featuresInstances, srvg.customer

export class VideoViewController extends ViewController implements ButtonViewDelegate {
    public name:string;
    private lastVideoReloadTime:string;

    // stores the last active channel to identify whether you can switch or not.
    // ! Use only here in videoViewController, otherwise you will can not avoid any strange behaviour!!!
    private lastActiveChannel:number;

    videoUrlPattern:string;
    toggledVideoUrlPattern:string;
    externalVideosetId:string;
    toggledExternalVideosetId:string;
    videoView:VideoView;
    videoControlBar:VideoControlBarView;
    vspConnection:NodeConnection;
    options;

    constructor(options) {
        super(options);
        options = options || {};
        options.view = options.videoView || null;
        options.name = options.name || 'videoController';
        this.options = options;

        this.videoView = options.videoView || null;
        //      console.log(JSON.stringify(this.videoView));
        this.videoControlBar = options.videoControlBar || null;

        this.lastActiveChannel = srvg.videooptions.defaultchannel || 0;

        this.videoUrlPattern = '';
        this.toggledVideoUrlPattern = '';

        this.externalVideosetId = null;
        if (srvg.videooptions.external_videoset_id) {
            this.externalVideosetId = srvg.videooptions.external_videoset_id;
        }
        this.toggledExternalVideosetId = null;
        if (srvg.videooptions.alt_external_videoset_id) {
            this.toggledExternalVideosetId = srvg.videooptions.alt_external_videoset_id;
        }

        this.vspConnection = null;

        // Initialize URL patterns
        // Usually, we start with the alternative video if it is available, but not when the start_with_hd option is set.
        if (srvg.Player.getWorkingStreamType() == 'flash') {
            if (srvg.videooptions.alt_videobasename && !srvg.featuresInstances.getStartWithHd()) {
                this.videoUrlPattern = srvg.videooptions.serverurl + srvg.videooptions.alt_videobasename + '$channel$';
                this.toggledVideoUrlPattern = srvg.videooptions.serverurl + srvg.videooptions.videobasename + '$channel$';
                var tmp = this.externalVideosetId;
                this.externalVideosetId = this.toggledExternalVideosetId;
                this.toggledExternalVideosetId = tmp;
            }
            else {
                this.videoUrlPattern = srvg.videooptions.serverurl + srvg.videooptions.videobasename + '$channel$';
                this.toggledVideoUrlPattern = srvg.videooptions.serverurl + srvg.videooptions.alt_videobasename + '$channel$';
            }
        } else {
            if (srvg.videooptions.alt_videobasename && !srvg.featuresInstances.getStartWithHd()) {
                this.videoUrlPattern = srvg.videooptions.iosserverurl + srvg.videooptions.alt_iosvideobasename + '$channel$' + '/playlist.m3u8';
                this.toggledVideoUrlPattern = srvg.videooptions.iosserverurl + srvg.videooptions.iosvideobasename + '$channel$' + '/playlist.m3u8';
                var tmp = this.externalVideosetId;
                this.externalVideosetId = this.toggledExternalVideosetId;
                this.toggledExternalVideosetId = tmp;
            }
            else {
                this.videoUrlPattern = srvg.videooptions.iosserverurl + srvg.videooptions.iosvideobasename + '$channel$' + '/playlist.m3u8';
                this.toggledVideoUrlPattern = srvg.videooptions.iosserverurl + srvg.videooptions.alt_iosvideobasename + '$channel$' + '/playlist.m3u8';
            }
        }
        if (this.videoUrlPattern != '' && this.externalVideosetId != null) {
            this.videoUrlPattern += '@$external_channel_id$';
        }
        if (this.toggledVideoUrlPattern != '' && this.toggledExternalVideosetId != null) {
            this.toggledVideoUrlPattern += '@$external_channel_id$';
        }
        if (this.videoControlBar) {
            this.videoControlBar.playpauseButton.setDelegate(this);
            this.videoControlBar.hdButton.setDelegate(this);
            this.videoControlBar.soundButton.setDelegate(this);
        }
    }

    /**
     * initialize local storage by creating a socket connection to the VSP
     */
    initializeLocalStorage() {
        var that = this;
        var jpc = function (data) {
        };
        var player = this.videoView.player;

        try {
            player.addEventListener().error(function (e) {
                var data = {
                    s4Id: srvg.customer.clientId | 0,
                    video: this.getAttribute('src'),
                    networkState: this.parentNode.networkState,
                    location: document.location.href
                };
                $.ajax('//' + srvg.videooptions.vspHost + '/er', {
                    cache: false,
                    crossDomain: true,
                    dataType: 'jsonp',
                    jsonpCallback: jpc,
                    data: {
                        data: JSON.stringify(data)
                    }
                });
            });
        } catch (ignore) {
        }

        srvg.flost.findDefaultVideoSet(srvg.videooptions.flostVideoHostUrl, srvg.videooptions.flostVideosets, true, function (extension, url) {
            if (that.vspConnection) {
                // we already have a functioning video set
                return;
            }
            //console.log( 'default videoset found', extension, url );
            var videoset = url.replace(srvg.videooptions.flostVideoHostUrl, '').split('/')[0];
            srvg.videooptions.flostVideosetUrl = srvg.videooptions.flostVideoHostUrl + videoset + '/';
            switch (extension) {
                case 'webm':
                    player.getContainerElement().firstChild.type = 'video/' + extension;
                    break;
            }
            srvg.videooptions.extensions.video = '.' + extension;
            that.videoUrlPattern = url;
            that.play();
            // Delay setting the loop feature until after the video has started
            window.setTimeout(
                function () {
                    that.videoView.setLooping(true);
                },
                3000
            );

            // connect to the vsp host and listen for incoming video channel data
            that.vspConnection = new NodeConnection({
                server: srvg.videooptions.vspHost,
                isSSL: srvg.videooptions.vspSSL
            });
            that.vspConnection.addSubscriberForEvent(that, DataReceiveEvent);
            that.vspConnection.connect({
                videoset: videoset,
                instance_channelpattern_id: srvg.videooptions.instanceChannelpattern || null,
                client_id: srvg.customer.clientId
            });
            that.vspConnection.addAction('init');
            that.vspConnection.addAction('play');
        });
    }

    /**
     * Constructs a new video url according to current settings and tells the player to load and play it
     */
    play(channel?:number, playMode?:string, lastActive?:number) {
        playMode = playMode || '';
        lastActive = lastActive || 0;

        if (!channel && channel !== 0) {
            channel = this.lastActiveChannel;
        }
        if (!channel && channel !== 0) {
            channel = app.timeline.currentChannel;
        }
        if (srvg.flost) {
            var data = srvg.flost.getChannelData(channel);
            if (data) {
                // TODO set poster if necessary
                if (data.key) {
                    this.videoUrlPattern = srvg.flost.crypto.getUrl(data.url + srvg.videooptions.extensions.video, data.key);
                    //console.log( 'Crypto activated', data, this.videoUrlPattern );
                } else {
                    this.videoUrlPattern = srvg.videooptions.flostVideosetUrl + data.url + srvg.videooptions.extensions.video;
                    //console.log( 'No crypto', data, this.videoUrlPattern );
                }
            }
        }
        var videourl = this.videoUrlPattern;
        // replace channel id in url pattern
        if (videourl.indexOf('$channel$') != -1) {
            videourl = videourl.replace('$channel$', channel.toString());
        }
        // replace external channel id in url pattern (Akamai)
        if (videourl.indexOf('$external_channel_id$') != -1) {
            videourl = videourl.replace(/\$external_channel_id\$/, '' + this.externalVideosetId);
        }
        //      console.log(typeof this.videoView, 'type', JSON.stringify(this.videoView));
        if(this.videoView === null){
            this.videoView = new VideoView(this.options, srvg);
        }
        this.videoView.playUrl(videourl, playMode, lastActive);
    }

    // ************************** Event handlers **************************

    handleTimeoutEvent(event, provider) {
        this.videoView.stop();
    }

    handleChannelSwitchEvent(event:ChannelSwitchEvent, provider) {

        srvg.buttonActivity = 'blocked';

        if (this.lastActiveChannel !== event.newChannel) {
            let leftChannel = this.lastActiveChannel;
            this.lastActiveChannel = event.newChannel;

            if (srvg.flostCheck.isFlost === true) {
                this.play(this.lastActiveChannel, 'channelSwitch', leftChannel);

                // if video is off, turn it on
                if (this.videoControlBar && this.videoControlBar.playpauseButton.$domNode.hasClass('pressed')) {
                    this.videoView.setPaused(false);
                    $(this.videoView.selector + ' .poster-image').hide();
                    $('#videoControlbar').removeClass('paused');
                    $('.button.whenplaying.enabled').show();
                    this.videoControlBar.playpauseButton.$domNode.toggleClass('pressed');
                }
            } else {
                // new playerclass channel switching

                var channel = this.lastActiveChannel;
                var hd = this.videoView.player._anchor.getAttribute("data-status").indexOf("is-hd") > -1 ? true : false;

                if(!srvg.isMobile){

                    // forcePlay: false = channel switch but player not starting, forcePlay: true = regular channel switch
                    // arguments: channel, hd, isInternal, forcePlay
                    this.videoView.player.api.switchChannel(channel, hd, false, true);

                }else{

                    this.videoView.player.api.switchChannelMobile(channel);
                }

            }
        }
        else {
            console.log('New channel equals old channel; ignoring');
        }
    }

    /**
     * handle video reload event for reloading video on setting in database
     * if forceVideoReload wasn't set, the timestamp is stored in the variable but doesn't trigger the reload
     * if you want to also trigger the reload, set forceVideoReload to true
     * @param event
     * @param [bool event.forceVideoReload]
     * @param string event.videoReload contains the settings from the database, e.g. timestamp
     */
    handleVideoReloadEvent(event:VideoReloadEvent, provider) {
        var forceReload = event.force,
            videoReloadTime = event.time;

        if (videoReloadTime != '0' && videoReloadTime != this.lastVideoReloadTime) {
            if (forceReload) {
                this.videoView.reconnect();
            }
            this.lastVideoReloadTime = videoReloadTime;
        }
    }

    /**
     * Only used for FLOST. Handles setting of background images
     */
    handlePhaseChangeEvent(event:PhaseChangeEvent, provider) {
        if (srvg.videooptions.flostVideosetUrl) {
            var that = this;
            if (event.phase.name === 'pre_sportevent') {
                // Delay setting the background image until after the video has started
                window.setTimeout(
                    function () {
                        that.videoView.setBackgroundImage(srvg.videooptions.flostVideosetUrl + 'images/intro/intro.jpg');
                    },
                    3000
                );
            }
            else if (event.phase.name === 'sportevent') {
                var matches = this.videoView.currentVideoUrl.match(/\/([0-9]+)\/[^\/]+$/);
                if (matches && matches.length) {
                    // Delay setting the background image until after the video has started
                    window.setTimeout(
                        function () {
                            that.videoView.setBackgroundImage(srvg.videooptions.flostVideosetUrl + 'images/matchstats/matchstats_' + matches[1] + '.jpg');
                        },
                        10000
                    );
                }
            }
        }
    }

    handleDataReceiveEvent(event:DataReceiveEvent, provider) {
        var data = event.data.data;
        var action = event.data.action;
        srvg.debug.console('info', 'received vsp "' + action + '"', data);
        if (action == 'play' || action == 'init') {
            srvg.flost.setChannel(data); // should be called setChannelData()
            if (data.channel == app.timeline.currentChannel) {
                this.videoView.setLooping(false);
                this.play();
                if (this.videoView.playerOptions.muted) {
                    // FIXME for some reason the player doesn't retain the muted setting, therefore we set it to mute again
                    this.videoView.setMute(true);
                }

            }
        }
    }

    handlePlaybackStartEvent(event:PlaybackStartEvent, provider) {
        if (srvg.flost) {
            var channelData = srvg.flost.getChannelData(app.timeline.currentChannel);
            if (channelData && event.mediaUrl.indexOf(channelData.url) != -1) {
                srvg.debug.console('seek ' + ( Date.now() - channelData.time ));
                // channel data stores the time the channel should have started playing
                // if we subtract this from the current time, we know how far ahead we have to seek
                this.videoView.seek(Date.now() - channelData.time);
            }
        }
    }

    handleButtonClickEvent(event:ButtonClickEvent, button:ButtonView) {

        if (srvg.buttonActivity && srvg.buttonActivity == "blocked") {
            return false;
        }

        if ($(this.videoView.selector).children(0).hasClass('is-loading')) {
            return false;
        }

        if (button == this.videoControlBar.playpauseButton) {

            // switch on
            if (button.$domNode.hasClass('pressed')) {
                //console.log('Api', srvg.player.api, this.videoView.currentVideoUrl, $(this.videoView.selector + ' .poster-image'));


                srvg.stopMe = function (player, url) {
                    var $d = $.Deferred();
                    var stop = function () {
                        //             console.log('player stop', url);
                        player.play(url);
                    };
                    stop();
                    if (!srvg.myTimeout) {
                        srvg.myTimeout = setTimeout(function () {
                            $d.resolve();
                        }, 500);
                    } else {
                        clearTimeout(srvg.myTimeout);
                        srvg.myTimeout = setTimeout(function () {
                            $d.resolve();
                        }, 500);
                    }
                    return $d.promise();
                };

                if (srvg.videoplayer.type == "flowplayer") {

                    srvg.stopMe(srvg.player.api, srvg.player.api.video.url).done(function () {
                        //console.log('Player neu gestartet');
                    });

                    $(this.videoView.selector + ' .poster-image').removeClass('poster-image').removeClass('is-poster');
                    $('.button.whenplaying.enabled').show();
                    this.videoControlBar.$domNode.removeClass('paused');

                } else if (srvg.videoplayer.type == "liveplayer") {

                    this.play();
                    $(this.videoView.selector + ' .poster-image').hide();
                    $('.button.whenplaying.enabled').show();
                    this.videoControlBar.$domNode.removeClass('paused');
                }

            }
            else {
                //switch off
                this.videoView.stop();
                $(this.videoView.selector + ' .poster-image').show();
                // IE 11 CSS for ambassador
                if (navigator.userAgent.indexOf('rv:11') > 0) {
                    $(this.videoView.selector + ' .poster-image').addClass('ie11');
                }
                $('.button.whenplaying.enabled').hide();
                // spinner will be automatically shown again if needed
                $(this.videoView.spinnerSelector).hide();
                this.videoControlBar.$domNode.addClass('paused');
            }
            button.$domNode.toggleClass('pressed');
        }
        else if (button == this.videoControlBar.hdButton) {
            if (this.toggledVideoUrlPattern !== '') {
                // swap video url patterns
                var pattern = this.videoUrlPattern;
                this.videoUrlPattern = this.toggledVideoUrlPattern;
                this.toggledVideoUrlPattern = pattern;

                // swamp external channel ids
                var tmp = this.externalVideosetId;
                this.externalVideosetId = this.toggledExternalVideosetId;
                this.toggledExternalVideosetId = tmp;
                //console.log('HD Play');
                srvg.myHD = 1;
                this.play();
            }
            button.$domNode.toggleClass('pressed');
        }
        else if (button == this.videoControlBar.soundButton) {
            if (button.$domNode.hasClass('pressed')) {
                this.videoView.setMute(false);
            }
            else {
                this.videoView.setMute(true);
            }
            button.$domNode.toggleClass('pressed');
        }
    }
}
